import {
  attendantHairColorBlack,
  attendantHairColorBlond,
  attendantHairColorBrown,
  attendantHairColorGray,
  attendantHairColorMultiColor,
  attendantHairColorRed,
  attendantHairColorSilver,
} from '@bells/i18n';
import type { Locale } from '@bells/i18n/runtime';
import {
  AttendantProfileState,
  HairColor,
} from '@bells/schema/models/attendant';
import { HairColorHexMap } from '@bells/types/attendant';

export const AttendantProfileColors = {
  [AttendantProfileState.INACTIVE]: 'bg-muted-foreground',
  [AttendantProfileState.APPROVED]: 'bg-green-500',
  [AttendantProfileState.BLOCKED]: 'bg-destructive',
  [AttendantProfileState.FIRST_CALL]: 'bg-orange-500',
  [AttendantProfileState.ON_VERIFICATION]: 'bg-purple-500',
  [AttendantProfileState.ON_ONBOARDING]: 'bg-foreground',
  [AttendantProfileState.ONBOARDED]: 'bg-foreground',
  [AttendantProfileState.REJECTED]: 'bg-destructive',
  [AttendantProfileState.REGISTERED]: 'bg-blue-500',
} as { [key: string]: string };

export const HairColors = (language: Locale) => {
  return [
    {
      value: HairColor.BLACK,
      label: attendantHairColorBlack(language),
      icon: (
        <span
          className='h-4 w-4 rounded-full'
          style={{ background: HairColorHexMap.BLACK }}
        ></span>
      ),
    },
    {
      value: HairColor.GRAY,
      label: attendantHairColorGray(language),
      icon: (
        <span
          className='h-4 w-4 rounded-full'
          style={{ background: HairColorHexMap.GRAY }}
        ></span>
      ),
    },
    {
      value: HairColor.SILVER,
      label: attendantHairColorSilver(language),
      icon: (
        <span
          className='h-4 w-4 rounded-full'
          style={{ background: HairColorHexMap.SILVER }}
        ></span>
      ),
    },
    {
      value: HairColor.BROWN,
      label: attendantHairColorBrown(language),
      icon: (
        <span
          className='h-4 w-4 rounded-full'
          style={{ background: HairColorHexMap.BROWN }}
        ></span>
      ),
    },
    {
      value: HairColor.BLOND,
      label: attendantHairColorBlond(language),
      icon: (
        <span
          className='h-4 w-4 rounded-full'
          style={{ background: HairColorHexMap.BLOND }}
        ></span>
      ),
    },

    {
      value: HairColor.RED,
      label: attendantHairColorRed(language),
      icon: (
        <span
          className='h-4 w-4 rounded-full'
          style={{ background: HairColorHexMap.RED }}
        ></span>
      ),
    },

    {
      value: HairColor.MULTI_COLOR,
      label: attendantHairColorMultiColor(language),
      icon: (
        <span
          className='h-4 w-4 rounded-full'
          style={{
            background:
              'linear-gradient(to right, red, orange, yellow, green, blue, indigo, violet)',
          }}
        ></span>
      ),
    },
  ];
};
